import { useQuery } from '@tanstack/react-query';
import { useParams, Link } from "react-router-dom";
import { getUrl } from '../../App';
import { GameTable } from '../TeamGameTable/TeamGameTable';
import { TeamIcon } from '@shared/components/TeamCard/TeamCard';
import styles from './TeamDetailView.module.css';

const fetch_teams = async (id) => {
    const response = await fetch(`${getUrl()}/api/teams/${id}`, { credentials: 'include', });
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
}

const fetch_events = async () => {
    const response = await fetch(`${getUrl()}/api/events?is_testevent=false`, { credentials: 'include', });
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
}

const fetch_games = async () => {
    const response = await fetch(`${getUrl()}/api/games?is_testgame=false`, { credentials: 'include', });
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
}


const TeamDetailView = () => {
    const { id } = useParams();
    const team = useQuery({
        queryKey: ['team', id],
        queryFn: () => fetch_teams(id),
        staleTime: 5 * 60 * 1000, // Cache data for 5 minutes
        cacheTime: 5 * 60 * 1000,
    });

    const events = useQuery({
        queryKey: ['events'],
        queryFn: () => fetch_events(),
        staleTime: 5 * 60 * 1000, // Cache data for 5 minutes
        cacheTime: 5 * 60 * 1000,
    });

    const games = useQuery({
                queryKey: ['games'], queryFn: () => fetch_games(),
                staleTime: 5 * 60 * 1000, // Cache data for 5 minutes
                cacheTime: 5 * 60 * 1000,
    });

    const getTeamStats = (team_id) => {
    if (!games || !games.data) {
        return { gamesPlayed: 0, wins: 0, totalGoals: 0 };
    }

    return games.data.reduce((stats, game) => {
        if ((game.team1 === team_id || game.team2 === team_id) && game.half === "half1") {
            stats.gamesPlayed++;

            if (game.score) {
    
                const [score1, score2] = game.score.split(':').map(Number);
                let teamGoals = 0;
                let opponentGoals = 0;

                if (game.team1 === team_id) {
                    teamGoals = score1;
                    opponentGoals = score2;
                } else {
                    teamGoals = score2;
                    opponentGoals = score1;
                }
                stats.totalGoals += teamGoals;
                
                if (teamGoals > opponentGoals) {
                    stats.wins++;
                }
            }
        }
        return stats;
    }, { gamesPlayed: 0, wins: 0, totalGoals: 0 });
};

    if (team.isError) {
        return <div>Error fetching teams: {team.error.message}</div>;
    }

    if (team.isLoading || events.isLoading || games.isLoading) {
        return (
            <div className="view-content">
                <div className="panel-header">
                    <h3>Team Detail View</h3>
                </div>
            </div >
        )
    }

    const { gamesPlayed, wins, totalGoals } = getTeamStats(team.data.id);

    return (
        <div className={styles.view_content}>
            <div className="panel-header">
                <h3>{`${team.data.name} Overview`}</h3>
            </div>
            <div className={styles.projects_section}>
                <div className={styles.project_boxes}>
                    <div className={styles.team_header}>
                        <div className={styles.team_logo}>
                            <img src={TeamIcon(team.data.team_id)} alt={`logo of team :${team.data.name} `} />
                        </div>
                        <div className={styles.team_info}>
                            <h3>{`Total Games Played: ${gamesPlayed}`}</h3>
                            <h3>{`Total Goals: ${totalGoals}`}</h3>
                            <h3>{`Total Wins: ${wins}`}</h3>
                        </div>

                    </div>
                    <div>
                    {events.data.length > 0 ? (
                        <>
                            {[...events.data] 
                                .sort((a, b) => {
                                if (a.name < b.name)  return 1;
                                if (a.name > b.name)  return -1;
                                return 0;
                            }) 
                                .map((event) => (
                                    <GameTable
                                        event={event}
                                        team={team.data}
                                        key={event.name} 
                                    />
                                ))
                            }
                        </>
                    ) : (
                        <div className={styles.emptyState}>
                            Team didn't participated
                        </div>
                    )}
                    </div>
                </div>
            </div>
        </div>)
};

export default TeamDetailView;